import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components';
import { Footer } from '../../containers';
import Seo from '../../seo/Seo';
import { breadcrumbSchema, webPageSchema } from '../../seo/schemas';
import './legal.css';

/**
 * Shared layout used by all legal/support pages.
 * Renders Navbar + hero banner + content container + Footer.
 *
 * SEO: `seoTitle` (sin sufijo de marca), `description` y `path` alimentan <Seo>
 * (title, canonical, Open Graph, BreadcrumbList).
 */
const LegalPageLayout = ({
    seoTitle,
    description,
    path,
    breadcrumbLabel,
    title,
    subtitle,
    lastUpdated,
    children,
}) => {
    return (
        <div className="legal-page">
            <Seo
                title={seoTitle || title}
                description={description || subtitle}
                path={path}
                jsonLd={[
                    webPageSchema({ path, title: seoTitle || title, description: description || subtitle }),
                    breadcrumbSchema([
                        { name: 'Inicio', path: '/' },
                        { name: breadcrumbLabel, path },
                    ]),
                ]}
            />
            <Navbar />

            <section className="legal-page__hero">
                <div
                    className="legal-page__hero-overlay"
                    style={{ backgroundImage: 'url(/assets/custom/images/big-overlay.jpg)' }}
                    aria-hidden="true"
                />
                <div className="container">
                    <div className="row">
                        <div className="col-12 legal-page__hero-inner" data-reveal="up">
                            <div className="legal-page__breadcrumb">
                                <Link to="/">Inicio</Link>
                                <span className="legal-page__breadcrumb-sep">/</span>
                                <span>{breadcrumbLabel}</span>
                            </div>
                            <h1 className="legal-page__title">{title}</h1>
                            {subtitle && (
                                <p className="legal-page__subtitle">{subtitle}</p>
                            )}
                            {lastUpdated && (
                                <span className="legal-page__updated">
                                    Última actualización: {lastUpdated}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className="legal-page__body">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">{children}</div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default LegalPageLayout;
